import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c321ce80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label", "onKeydown"]
const _hoisted_3 = { class: "module-sidebar__heading" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "module-sidebar__nav" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label", "title", "aria-expanded"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["aria-label", "title", "aria-expanded"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "module-sidebar__flyout-title" }

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  BriefcaseIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronDownIcon,
  CogIcon,
  TerminalIcon,
} from "@heroicons/vue/outline";
import { t } from "@/i18n";
import PlatformCompaniesIcon from "@/components/common/PlatformCompaniesIcon.vue";
import { AuthGetters } from "@/store/modules/auth";
import layoutRoutes from "./layoutRoutes";


export default /*#__PURE__*/_defineComponent({
  props: {
    templates: null,
    mobileExpanded: null
  },
  emits: ["update:mobileExpanded", "availability"],
  setup(__props: any, { emit }: { emit: ({
  (event: "update:mobileExpanded", value: boolean): void;
  (event: "availability", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { templates: any[]; mobileExpanded?: boolean }

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */


const route = useRoute();
const hrSections = [
  { code: "CONTRACT", name: "Сотрудники по ТД" },
  { code: "GPH", name: "Сотрудники по ГПХ" },
];
const store = useStore();
const identity = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const canAccessHr = computed(
  () => identity.value?.permissions?.includes("HR_VIEW") === true
);
const isPlatformAdmin = computed(() => identity.value?.platformAdmin === true);
const systemTemplate = computed(() =>
  props.templates.find(
    (item) => item.code === "SYSTEM_CONFIG" && item.hasAccess
  )
);
const canViewLogs = computed(
  () =>
    systemTemplate.value?.childs?.some(
      (child: any) => child.code === "EDMS_LOGS" && child.hasAccess
    ) === true ||
    props.templates.some((item) => item.code === "EDMS_LOGS" && item.hasAccess)
);
const controlPanelOrder = [
  "USER",
  "COMPANY",
  "DOCUMENT_TEMPLATE",
  "DOCUMENT_CONSTRUCTOR",
  "ENTITY_APPROVAL",
  "REPORTS",
  "DOCUMENT_STRUCTURE",
  "NOMENCLATURE",
  "JOB",
  "PROCESS_TEMPLATE",
  "ROLE",
];
const controlPanelLabels: Record<string, string> = {
  USER: t("navbar.users"),
  COMPANY: t("navbar.companies"),
  DOCUMENT_TEMPLATE: t("navbar.templates"),
  DOCUMENT_CONSTRUCTOR: t("navbar.categories"),
  ENTITY_APPROVAL: t("navbar.entityApproval"),
  REPORTS: t("navbar.reports"),
  DOCUMENT_STRUCTURE: t("navbar.structures"),
  NOMENCLATURE: t("navbar.nomenclatures"),
  JOB: t("navbar.positions"),
  PROCESS_TEMPLATE: t("navbar.processes"),
  ROLE: t("navbar.roles"),
};
const controlChildren = computed(() => {
  if (!systemTemplate.value) return [];
  const existing = (systemTemplate.value.childs || []).filter(
    (child: any) => child.hasAccess
  );
  // Preserve the additional sections already present in the control panel.
  const manual = [
    {
      code: "ENTITY_APPROVAL",
      hasAccess:
        identity.value?.permissions?.includes("ENTITY_APPROVAL_COORDINATE") ===
        true,
    },
    { code: "DOCUMENT_STRUCTURE", hasAccess: true },
    { code: "REPORTS", hasAccess: true },
  ];
  const byCode = new Map<string, any>();
  [...existing, ...manual.filter((child) => child.hasAccess)].forEach(
    (child) => {
      if (controlPanelOrder.includes(child.code)) {
        byCode.set(child.code, {
          ...child,
          name: controlPanelLabels[child.code] || child.name,
        });
      }
    }
  );
  return controlPanelOrder.map((code) => byCode.get(code)).filter(Boolean);
});
const hasSections = computed(
  () =>
    canAccessHr.value ||
    controlChildren.value.length > 0 ||
    canViewLogs.value ||
    isPlatformAdmin.value
);
watch(hasSections, (value) => emit("availability", value), { immediate: true });
function matchesPath(path: string) {
  return route.path === path || route.path.startsWith(path + "/");
}
function childLocation(child: any) {
  const query: Record<string, string> = {};
  if (child.templateId) query.templateId = String(child.templateId);
  if (child.type) query.type = String(child.type);
  return { path: layoutRoutes[child.code], query };
}
function childActive(child: any) {
  const location = childLocation(child);
  return (
    matchesPath(location.path) &&
    Object.entries(location.query).every(
      ([key, value]) => route.query[key] === value
    )
  );
}
const isHrRoute = computed(() => matchesPath(layoutRoutes.HR));
const isLogsRoute = computed(() => matchesPath(layoutRoutes.EDMS_LOGS));
const isTenantRoute = computed(() => route.name === "TenantManagement");
const controlActive = computed(() => controlChildren.value.some(childActive));

const storageKey = "app-module-sidebar-collapsed";
function readCollapsed() {
  try {
    return localStorage.getItem(storageKey) === "true";
  } catch {
    return false;
  }
}
const collapsed = ref(readCollapsed());
const mobileQuery = window.matchMedia("(max-width: 1024px)");
const isMobile = ref(mobileQuery.matches);
const mobileExpanded = computed({
  get: () => props.mobileExpanded === true,
  set: (value: boolean) => emit("update:mobileExpanded", value),
});
const compact = computed(() =>
  isMobile.value ? !mobileExpanded.value : collapsed.value
);
const collapseLabel = computed(() =>
  compact.value ? t("layout.expandSidebar") : t("layout.collapseSidebar")
);
const controlOpen = ref(false);
const sidebarElement = ref<HTMLElement | null>(null);
const controlButton = ref<HTMLButtonElement | null>(null);
const collapseButton = ref<HTMLButtonElement | null>(null);
const flyoutElement = ref<HTMLElement | null>(null);
const flyoutPosition = ref({ top: "80px", left: "72px", maxHeight: "400px" });

function closeControl(restoreFocus = false) {
  controlOpen.value = false;
  if (restoreFocus) controlButton.value?.focus();
}
function closeMobilePanel() {
  if (mobileExpanded.value) {
    mobileExpanded.value = false;
    closeControl();
  }
}
function closeNavigation() {
  if (controlOpen.value) closeControl(true);
  else closeMobilePanel();
}
async function toggleControl() {
  controlOpen.value = !controlOpen.value;
  if (!controlOpen.value || !compact.value) return;
  await nextTick();
  const rect = controlButton.value?.getBoundingClientRect();
  const sidebarRect = sidebarElement.value?.getBoundingClientRect();
  const flyout = flyoutElement.value;
  if (!rect || !sidebarRect || !flyout) return;
  const maxHeight = Math.max(120, window.innerHeight - 88);
  const height = Math.min(flyout.scrollHeight, maxHeight);
  flyoutPosition.value = {
    top:
      Math.max(72, Math.min(rect.top, window.innerHeight - height - 16)) + "px",
    left: sidebarRect.right + 8 + "px",
    maxHeight: maxHeight + "px",
  };
  await nextTick();
  flyout.querySelector<HTMLElement>("a")?.focus();
}
function toggleCollapsed() {
  closeControl();
  if (isMobile.value) mobileExpanded.value = !mobileExpanded.value;
  else {
    collapsed.value = !collapsed.value;
    try {
      localStorage.setItem(storageKey, String(collapsed.value));
    } catch {
      // The panel still works when the browser blocks preference storage.
    }
  }
}
function handleOutsideClick(event: PointerEvent) {
  const target = event.target as Node;
  if (
    compact.value &&
    !sidebarElement.value?.contains(target) &&
    !flyoutElement.value?.contains(target)
  ) {
    closeControl();
  }
}
function handleResize() {
  isMobile.value = mobileQuery.matches;
  mobileExpanded.value = false;
  closeControl();
}
watch(
  [() => route.fullPath, controlActive, compact],
  () => {
    if (compact.value) closeControl();
    else if (controlActive.value) controlOpen.value = true;
  },
  { immediate: true }
);
watch(() => route.fullPath, closeMobilePanel);
onMounted(() => {
  document.addEventListener("pointerdown", handleOutsideClick);
  window.addEventListener("resize", handleResize);
});
onBeforeUnmount(() => {
  document.removeEventListener("pointerdown", handleOutsideClick);
  window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(hasSections))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["module-sidebar-shell", { 'module-sidebar-shell--compact': _unref(compact) }])
      }, [
        (_unref(mobileExpanded))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "module-sidebar__backdrop",
              type: "button",
              "aria-label": _unref(t)('layout.closeSections'),
              onClick: closeMobilePanel
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("aside", {
          id: "app-module-navigation",
          ref: (_value, _refs) => {
            _refs['sidebarElement'] = _value
            sidebarElement.value = _value
          },
          class: _normalizeClass(["module-sidebar", { 'module-sidebar--compact': _unref(compact) }]),
          "aria-label": _unref(t)('layout.sections'),
          onKeydown: _withKeys(_withModifiers(closeNavigation, ["stop"]), ["esc"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (!_unref(compact))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)("layout.sections")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("nav", _hoisted_5, [
            (_unref(canAccessHr))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'HrEmployeeList' },
                  class: _normalizeClass(["module-sidebar__link", { 'module-sidebar__link--active': _unref(isHrRoute) }]),
                  "aria-current": _unref(isHrRoute) ? 'page' : undefined,
                  "aria-label": _unref(t)('hr.module'),
                  title: _unref(compact) ? _unref(t)('hr.module') : undefined,
                  onClick: closeMobilePanel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BriefcaseIcon), { class: "module-sidebar__icon" }),
                    (!_unref(compact))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)("hr.module")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class", "aria-current", "aria-label", "title"]))
              : _createCommentVNode("", true),
            (_unref(canAccessHr) && _unref(isHrRoute) && !_unref(compact))
              ? (_openBlock(), _createElementBlock("nav", {
                  key: 1,
                  class: "module-sidebar__children",
                  "aria-label": _unref(t)('hr.module')
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hrSections, (section) => {
                    return _createVNode(_component_router_link, {
                      key: section.code,
                      to: { name: 'HrEmployeeList', query: { employmentType: section.code } },
                      class: _normalizeClass(["module-sidebar__child", { 'module-sidebar__child--active': _unref(route).name === 'HrEmployeeList' && (_unref(route).query.employmentType || 'CONTRACT') === section.code }]),
                      onClick: closeMobilePanel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(section.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"])
                  }), 64)),
                  _createVNode(_component_router_link, {
                    to: { name: 'HrAnalytics' },
                    class: _normalizeClass(["module-sidebar__child", { 'module-sidebar__child--active': _unref(route).name === 'HrAnalytics' }]),
                    onClick: closeMobilePanel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("hr.analytics")), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_unref(controlChildren).length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  ref: (_value, _refs) => {
                    _refs['controlButton'] = _value
                    controlButton.value = _value
                  },
                  type: "button",
                  class: _normalizeClass(["module-sidebar__link", { 'module-sidebar__link--active': _unref(controlActive) }]),
                  "aria-label": _unref(t)('navbar.control'),
                  title: _unref(compact) ? _unref(t)('navbar.control') : undefined,
                  "aria-expanded": controlOpen.value,
                  "aria-controls": "sidebar-control-panel",
                  onClick: toggleControl
                }, [
                  _createVNode(_unref(CogIcon), { class: "module-sidebar__icon" }),
                  (!_unref(compact))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)("navbar.control")), 1))
                    : _createCommentVNode("", true),
                  (!_unref(compact))
                    ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                        key: 1,
                        class: _normalizeClass(["module-sidebar__chevron", { 'module-sidebar__chevron--open': controlOpen.value }])
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_8))
              : _createCommentVNode("", true),
            (controlOpen.value && !_unref(compact) && _unref(controlChildren).length)
              ? (_openBlock(), _createElementBlock("nav", {
                  key: 3,
                  id: "sidebar-control-panel",
                  class: "module-sidebar__children",
                  "aria-label": _unref(t)('navbar.control')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controlChildren), (child) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: child.code,
                      to: childLocation(child),
                      class: _normalizeClass(["module-sidebar__child", { 'module-sidebar__child--active': childActive(child) }]),
                      "aria-current": childActive(child) ? 'page' : undefined,
                      onClick: closeMobilePanel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(child.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class", "aria-current"]))
                  }), 128))
                ], 8, _hoisted_10))
              : _createCommentVNode("", true),
            (_unref(canViewLogs))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: _unref(layoutRoutes).EDMS_LOGS,
                  class: _normalizeClass(["module-sidebar__link", { 'module-sidebar__link--active': _unref(isLogsRoute) }]),
                  "aria-current": _unref(isLogsRoute) ? 'page' : undefined,
                  "aria-label": _unref(t)('navbar.logs'),
                  title: _unref(compact) ? _unref(t)('navbar.logs') : undefined,
                  onClick: closeMobilePanel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TerminalIcon), { class: "module-sidebar__icon" }),
                    (!_unref(compact))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)("navbar.logs")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["to", "class", "aria-current", "aria-label", "title"]))
              : _createCommentVNode("", true),
            (_unref(isPlatformAdmin))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: { name: 'TenantManagement' },
                  class: _normalizeClass(["module-sidebar__link", { 'module-sidebar__link--active': _unref(isTenantRoute) }]),
                  "aria-current": _unref(isTenantRoute) ? 'page' : undefined,
                  "aria-label": _unref(t)('navbar.tenantManagement'),
                  title: _unref(compact) ? _unref(t)('navbar.tenantManagement') : undefined,
                  onClick: closeMobilePanel
                }, {
                  default: _withCtx(() => [
                    _createVNode(PlatformCompaniesIcon, { class: "module-sidebar__icon" }),
                    (!_unref(compact))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)("navbar.tenantManagement")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class", "aria-current", "aria-label", "title"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            ref: (_value, _refs) => {
              _refs['collapseButton'] = _value
              collapseButton.value = _value
            },
            type: "button",
            class: "module-sidebar__link module-sidebar__collapse",
            "aria-label": _unref(collapseLabel),
            title: _unref(compact) ? _unref(collapseLabel) : undefined,
            "aria-expanded": !_unref(compact),
            onClick: toggleCollapsed
          }, [
            (_unref(compact))
              ? (_openBlock(), _createBlock(_unref(ChevronDoubleRightIcon), {
                  key: 0,
                  class: "module-sidebar__icon"
                }))
              : (_openBlock(), _createBlock(_unref(ChevronDoubleLeftIcon), {
                  key: 1,
                  class: "module-sidebar__icon"
                })),
            (!_unref(compact))
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(collapseLabel)), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_13)
        ], 42, _hoisted_2), [
          [_vShow, !isMobile.value || _unref(mobileExpanded)]
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (controlOpen.value && _unref(compact) && _unref(controlChildren).length)
            ? (_openBlock(), _createElementBlock("nav", {
                key: 0,
                id: "sidebar-control-panel",
                ref: (_value, _refs) => {
                  _refs['flyoutElement'] = _value
                  flyoutElement.value = _value
                },
                class: "module-sidebar__flyout",
                style: _normalizeStyle(flyoutPosition.value),
                "aria-label": _unref(t)('navbar.control'),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (closeControl(true)), ["stop"]), ["esc"]))
              }, [
                _createElementVNode("strong", _hoisted_16, _toDisplayString(_unref(t)("navbar.control")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controlChildren), (child) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: child.code,
                    to: childLocation(child),
                    class: _normalizeClass(["module-sidebar__child", { 'module-sidebar__child--active': childActive(child) }]),
                    "aria-current": childActive(child) ? 'page' : undefined,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeControl()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(child.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "aria-current"]))
                }), 128))
              ], 44, _hoisted_15))
            : _createCommentVNode("", true)
        ]))
      ], 2))
    : _createCommentVNode("", true)
}
}

})